import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { ValidationParameters } from '../types/Validation';

dayjs.extend(utc);

/**
 * An object of methods that will return an error string depending on the type
 * of validation.
 */
export default {
  required: (): string => 'Required',
  maxLength: (params: ValidationParameters): string => `Maximum length: ${params.validation.value}`,
  minLength: (params: ValidationParameters): string => `Minimum length: ${params.validation.value}`,
  maxValue: (params: ValidationParameters): string => `Maximum value: ${params.validation.value}`,
  minValue: (params: ValidationParameters): string => `Minimum value: ${params.validation.value}`,
  minDate: (params: ValidationParameters): string => `Date cannot be before: ${dayjs.utc(params.validation.value).format('DD MMM YYYY UTC')}`,
  maxDate: (params: ValidationParameters): string => `Date cannot be after: ${dayjs.utc(params.validation.value).format('DD MMM YYYY UTC')}`,
};
